import Vue from 'vue'
import { getCaseGroupsApi, updateCaseGroupApi, saveCaseGroupApi, deleteCaseGroupApi } from "../../api/caseGroupApi"

const state = {
  caseGroups: []
}

const getters = {
  getCaseGroups: state => state.caseGroups
}

const actions = {
  async fetchCaseGroups({ commit }) {
    try {
      const caseGroups = await getCaseGroupsApi()
      commit('setCaseGroups', caseGroups)
      return Promise.resolve();
    } catch (error) {
      console.error('Error getting case groups.', error);
      commit('setCaseGroups', [])
      return Promise.reject(error)
    }
  },
  async addCaseGroup({ commit }, caseGroup) {
    try {
      const newCaseGroup = await saveCaseGroupApi(caseGroup)
      commit('addCaseGroup', newCaseGroup)
      return Promise.resolve();
    } catch (error) {
      console.error('Error adding case group.', error);
      return Promise.reject(error)
    }
  },
  async updateCaseGroup({ commit }, caseGroup) {
    try {
      const updatedCaseGroup = await updateCaseGroupApi(caseGroup)
      commit('editCaseGroup', updatedCaseGroup)
      return Promise.resolve();
    } catch (error) {
      console.error('Error updating case group.', error);
      return Promise.reject(error)
    }
  },
  async deleteCaseGroup({ commit }, caseGroup) {
    try {
      await deleteCaseGroupApi(caseGroup)
      commit('deleteCaseGroup', caseGroup)
      return Promise.resolve();
    } catch (error) {
      console.error('Error deleting case group.', error);
      return Promise.reject(error)
    }
  }
}

const mutations = {
  setCaseGroups: (state, caseGroups) => (state.caseGroups = caseGroups),
  addCaseGroup: (state, caseGroup) => (state.caseGroups.push(caseGroup)),
  editCaseGroup: function (state, caseGroup) {
    var index = state.caseGroups.findIndex((obj => obj.id == caseGroup.id))
    Vue.set(state.caseGroups, index, caseGroup)
  },
  deleteCaseGroup: (state, caseGroup) => (state.caseGroups
    = state.caseGroups.filter(thisCaseGroup => thisCaseGroup.id !== caseGroup.id)),
}

export default {
  state,
  actions,
  mutations,
  getters
}